import { Stack, TableCell, TableRow, Typography, styled } from "@mui/material";
import NoDataIcon from "../common/NoDataIcon";

export const EmptyTable = ({
    msg,
    colSpan,
}: {
    msg: string;
    colSpan?: number;
}) => {
    const StyledGridOverlay = styled(Stack)(() => ({
        height: "200px",
    }));
    return (
        <TableRow sx={{ bgcolor: "#11111105" }}>
            <TableCell colSpan={colSpan}>
                <StyledGridOverlay
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                >
                    <NoDataIcon />
                    <Typography align="center" color="#ccc">
                        {msg}
                    </Typography>
                </StyledGridOverlay>
            </TableCell>
        </TableRow>
    );
};

export default EmptyTable;
